// extracted by mini-css-extract-plugin
module.exports = {"moneyBack":"moneyBack_moneyBack__S824N","content":"moneyBack_content__173Hn","sum":"moneyBack_sum__2Dm7S"};